import React, { useEffect, useState } from 'react';
interface CountdownProps {
  initialHours?: number;
  initialMinutes?: number;
  initialSeconds?: number;
  className?: string;
}
export function Countdown({
  initialHours = 23,
  initialMinutes = 47,
  initialSeconds = 24,
  className = ''
}: CountdownProps) {
  const [timeLeft, setTimeLeft] = useState(() => {
    return initialHours * 3600 + initialMinutes * 60 + initialSeconds;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const intervalId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft]);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className={`flex items-center gap-2 font-mono font-bold text-gold-400 ${className}`} data-id="element-75">
      <div className="flex flex-col items-center" data-id="element-76">
        <span className="bg-navy-800 px-2 py-1 rounded text-lg md:text-xl border border-navy-700 shadow-inner" data-id="element-77">
          {formatTime(hours)}
        </span>
        <span className="text-[10px] text-text-secondary mt-1 uppercase tracking-wider font-sans" data-id="element-78">
          Horas
        </span>
      </div>
      <span className="text-xl pb-4" data-id="element-79">:</span>
      <div className="flex flex-col items-center" data-id="element-80">
        <span className="bg-navy-800 px-2 py-1 rounded text-lg md:text-xl border border-navy-700 shadow-inner" data-id="element-81">
          {formatTime(minutes)}
        </span>
        <span className="text-[10px] text-text-secondary mt-1 uppercase tracking-wider font-sans" data-id="element-82">
          Min
        </span>
      </div>
      <span className="text-xl pb-4" data-id="element-83">:</span>
      <div className="flex flex-col items-center" data-id="element-84">
        <span className="bg-navy-800 px-2 py-1 rounded text-lg md:text-xl border border-navy-700 shadow-inner" data-id="element-85">
          {formatTime(seconds)}
        </span>
        <span className="text-[10px] text-text-secondary mt-1 uppercase tracking-wider font-sans" data-id="element-86">
          Seg
        </span>
      </div>
    </div>;
}